module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_classicHover-e8f23a35a764319ef8b1e17b2c96f210.jpg";